<template>
  <div class="pick">
    <dl :class="{ready:isReady(data.outcomeid)}" v-for="(data, i) in detail.outcomeList" :key="i">
      <dt>{{ isReadyOwner(data.outcomeid) ? '방장 선택' : '도전자 대기중' }}</dt>
      <dd>{{ lang[data.kind] }} {{  data.dPoint }} / 배당률 {{ isReadyOwner(data.outcomeid) ? detail.owner_price : detail.guest_price }}</dd>
    </dl>
  </div>
</template>

<script>
  export default {
    name: "match-detail-item",
    props:[
      'detail'
    ],
    methods: {
      isReady(outcomeid) {
        if (this.detail.isOwner) {
          return this.detail.owner_outcome_id === outcomeid;
        } else {
          return this.detail.guest_outcome_id === outcomeid;
        }
      },
      isReadyOwner(outcomeid){
        return this.detail.owner_outcome_id === outcomeid;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-detail-item.vue